module.exports = __webpack_public_path__ + "static/media/tex_pc.eb39fe04.png";